export default __webpack_public_path__ + "static/media/gradeIcon.380263f8.svg";